let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6pvRv")).then(() => parcelRequire('5042u'));